import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the ventilatory threshold.
 **/
export const TextFieldVentilatoryThreshold = ({
    values,
    handleChange,
    errors,
    touched
}) => (
    <TextField
        fullWidth
        label={t('users.fields.vt2HR')}
        type="tel"
        name="ventilatoryThreshold"
        value={values.ventilatoryThreshold}
        error={touched.ventilatoryThreshold && Boolean(errors.ventilatoryThreshold)}
        helperText={touched.ventilatoryThreshold && errors.ventilatoryThreshold}
        onChange={handleChange}
    />
);

TextFieldVentilatoryThreshold.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
